import { uniq } from 'lodash-es';
import { type StateCreator } from 'zustand';
import { type AudioGraphStore } from './types';

export type AudioGraphErrorCode =
  | 'MIC_DISALLOWED'
  | 'NO_DEVICES'
  | 'DEVICE_IN_USE'
  | 'INTERRUPTED'
  | 'UNEXPECTED_ERROR';

export interface ErrorsSlice {
  errors: AudioGraphErrorCode[];
  hasError: () => boolean;
  addError: (error: AudioGraphErrorCode) => void;
  clearError: (error: AudioGraphErrorCode) => void;
}

export const createErrorsSlice: StateCreator<AudioGraphStore, [], [], ErrorsSlice> = (
  set,
  get
) => ({
  errors: [],
  hasError: () => get().errors.length > 0,

  addError: (code: AudioGraphErrorCode) => {
    set((state) => {
      const currentErrors = state.errors || [];
      const errors = uniq([...currentErrors, code]);

      if (errors.length > currentErrors.length) {
        get().logError({ event_type: 'ERROR_STATE_ADDED', details: { code, errors } });
      }

      return { errors };
    });
  },

  clearError: (code: AudioGraphErrorCode) => {
    // Clearing the permission error is the user's retry, so it lifts the block.
    if (code === 'MIC_DISALLOWED') get().unblockMic();
    set((state) => {
      const currentErrors = state.errors || [];
      const errors = currentErrors.filter((e) => e !== code);

      if (errors.length < currentErrors.length) {
        get().logDebug({ event_type: 'ERROR_CLEARED', details: { code, errors } });
      }

      return { errors };
    });
  },
});
